// extracted by mini-css-extract-plugin
export default {"fadeIn":"style_fadeIn__hhKzQ","logo":"style_logo__VEOQD"};